import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionReducer from "./sessionReducer";
import commonReducer from "./commonReducer";
import employeeReducer from "./employeeReducer";
import { SectionReducer, AppraisalReducer } from "pages/AppraisalManagment/reducers";
import { ObjectsReducer, ObjectTypesReducer, RolesReducer ,UsersRoleReducer, RolesAccessReducer } from "pages/AccessManagement/reducers";
import filterPersistenceReducer from "../store/filters/filterPersistenceSlice";
import { clearAllFiltersFromStorage, loadFiltersFromStorage } from "../store/filters/filterPersistenceStorage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["session"],
};

const filtersReducerWithHydration = (state, action) => {
  if (state === undefined) {
    return filterPersistenceReducer(loadFiltersFromStorage(), action);
  }
  return filterPersistenceReducer(state, action);
};

const appReducer = combineReducers({
  session: sessionReducer,
  commonState: commonReducer,
  employeeState: employeeReducer,
  sectionState: SectionReducer,
  appraisalState: AppraisalReducer, // Assuming ApprasalActions is a reducer
  objectsState:ObjectsReducer,
  objectTypesState:ObjectTypesReducer,
  rolesState: RolesReducer,
  commonState: commonReducer,
  usersRoleState :UsersRoleReducer,
  rolesAccessState: RolesAccessReducer,
  filters: filtersReducerWithHydration,
});

const RootReducer = (state, action) => {
  if (action.type === "TOKEN_EXPIRE" || action.type === "SESSION_LOGOUT") {
    localStorage.removeItem("token");
    sessionStorage.clear();
    clearAllFiltersFromStorage();
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default persistReducer(persistConfig, RootReducer);
